import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubPlaceholderPanel.module.css';

export default function ClubPlaceholderPanel({ title }) {
    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>{title}</h2>
            <div className={styles.placeholderPanel}>-</div>
        </section>
    );
}

